import React from 'react';
import { Link } from 'react-router-dom';
import './Tips.css';

interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  slug: string;
  readTime: string;
}

const Tips: React.FC = () => {
  const blogPosts: BlogPost[] = [
    {
      id: 1,
      title: "Check Your Tire Pressure Monthly",
      excerpt: "Learn why proper tire pressure is critical for trailer safety and how under-inflated tires can lead to dangerous blowouts on the highway.",
      slug: "check-tire-pressure-monthly",
      readTime: "3 min read"
    },
    {
      id: 2,
      title: "Grease Your Wheel Bearings Every Season",
      excerpt: "Discover how water and heat destroy wheel bearings and learn the maintenance schedule that will keep your wheels spinning safely.",
      slug: "wheel-bearing-maintenance",
      readTime: "5 min read"
    },
    {
      id: 3,
      title: "Use Two Safety Chains, Always",
      excerpt: "Safety chains are your last line of defense. Learn the proper X-pattern setup that could save your life if your hitch fails.",
      slug: "safety-chains-guide",
      readTime: "4 min read"
    },
    {
      id: 4,
      title: "Test Your Lights Before Every Trip",
      excerpt: "A simple pre-trip light check can prevent accidents and tickets. Here's your complete trailer lighting inspection checklist.",
      slug: "trailer-light-inspection",
      readTime: "3 min read"
    },
    {
      id: 5,
      title: "Balance Your Tongue Weight Properly",
      excerpt: "Wrong tongue weight causes dangerous trailer sway or poor vehicle handling. Learn the 10-15% rule that keeps you safe.",
      slug: "tongue-weight-guide",
      readTime: "4 min read"
    },
    {
      id: 6,
      title: "Rinse After Saltwater Use",
      excerpt: "Saltwater accelerates corrosion even on galvanized trailers. Follow this rinse procedure to protect your investment.",
      slug: "saltwater-maintenance",
      readTime: "3 min read"
    },
    {
      id: 7,
      title: "Winterizing Your Boat Trailer",
      excerpt: "Prepare your trailer for cold storage with this complete winterization checklist covering bearings, brakes, tires, and frame protection.",
      slug: "winterizing-trailer",
      readTime: "6 min read"
    },
    {
      id: 8,
      title: "How to Load Your Boat Correctly",
      excerpt: "Master the boat ramp with step-by-step loading techniques that prevent damage and make launching stress-free for everyone.",
      slug: "loading-boat-correctly",
      readTime: "5 min read"
    },
    {
      id: 9,
      title: "Trailer Brake Maintenance Guide",
      excerpt: "Keep your braking system reliable with our comprehensive maintenance guide covering both electric and surge brake systems.",
      slug: "brake-maintenance",
      readTime: "6 min read"
    },
    {
      id: 10,
      title: "How to Choose the Right Boat Trailer",
      excerpt: "Complete buying guide covering capacity calculations, trailer types, materials, features, and everything you need for the perfect match.",
      slug: "choosing-right-trailer",
      readTime: "7 min read"
    },
    {
      id: 11,
      title: "Common Trailer Problems & Troubleshooting",
      excerpt: "Diagnose and fix the most common trailer issues from electrical problems to brake failures with our expert troubleshooting guide.",
      slug: "troubleshooting-guide",
      readTime: "8 min read"
    }
  ];


  return (
    <section className="tips" id="tips">
      <div className="container">
        <div className="tips-header">
          <h2>Boat Trailer Tips & Guides</h2>
          <p>Expert advice and detailed guides to keep you safe on the road and extend your trailer's life.</p>
        </div>

        <div className="blog-grid">
          {blogPosts.map((post) => (
            <article key={post.id} className="blog-preview-card">
              <div className="blog-preview-meta">
                <span className="blog-preview-read-time">{post.readTime}</span>
              </div>
              <h3>{post.title}</h3>
              <p>{post.excerpt}</p>
              <Link to={`/tips/${post.slug}`} className="read-more-btn">
                Read Full Guide →
              </Link>
            </article>
          ))}
        </div>

        <div className="tips-cta">
          <h3>Need Professional Help?</h3>
          <p>Contact us for expert trailer advice and service recommendations.</p>
          <Link to="/contact" className="cta-btn">Get Expert Help</Link>
        </div>
      </div>
    </section>
  );
};

export default Tips;